import React from 'react'
import styles from './ComingSoonWorkflow.module.css'

interface ComingSoonWorkflowProps {
  name: string
  description?: string
}

const ComingSoonWorkflow: React.FC<ComingSoonWorkflowProps> = ({
  name,
  description = 'This workflow is coming soon. Stay tuned for updates.'
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            className={styles.icon}
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
        </div>
        <h1 className={styles.title}>{name}</h1>
        <p className={styles.description}>{description}</p>
        <span className={styles.badge}>Coming Soon</span>
      </div>
    </div>
  )
}

export default ComingSoonWorkflow
